import React from "react";
import pxToRem from "~libs/pxToRem";
import Link from "@mui/material/Link";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

interface StyleProps {
  marginBottom?: number | string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  base: (props) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: pxToRem(16),
    // `text.hint` fue eliminada de la paleta: este color no se aplica. Ver SEG-1521.
    color: (theme.palette.text as any).hint,
    lineHeight: 1.5,
    fontWeight: 400,
    marginBottom: props.marginBottom,
  }),
  purple: {
    color: `${theme.palette.primary.light} !important`,
    opacity: 0.79,
    fontWeight: `bold !important`,
    lineHeight: `2.13 !important`,
  },
}));

interface LinkButtonProps {
  label?: React.ReactNode;
  onClick?: () => void;
  variant?: string;
  marginBottom?: number | string;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  label,
  onClick,
  variant,
  marginBottom,
}) => {
  const classes = useStyles({ marginBottom });

  const variantClass = variant
    ? (classes as Record<string, string>)[variant]
    : undefined;
  const fullClasses =
    variantClass && variantClass !== classes.base
      ? [classes.base, variantClass].join(" ")
      : classes.base;

  return (
    <Link
      className={fullClasses}
      component="button"
      underline="always"
      onClick={onClick}
    >
      {label}
    </Link>
  );
};

export default LinkButton;
